import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 19h-6a8 8 0 0 1 -8 -8v-6","key":"svg-0"}]]

const IconRadiusBottomLeft = createReactComponent('outline', 'radius-bottom-left', 'RadiusBottomLeft', __iconNode);

export default IconRadiusBottomLeft;